import Fuse from "fuse.js";
import React from "react";
import { isLoading, Loading } from "../Loading";
import { AppPatientsState, Patient } from "../system/AppState/AppPatientsState";
import AutoCompleteDialog from "./AutoCompleteDialog";

interface Props {
  patientsState: Loading | AppPatientsState;
  isOpen: boolean;
  placeholder: string;
  defaultValue?: string;
  onClickPatient: (patient: Patient) => void;
  onRequestClose: () => void;
}

export default function SearchPatientDialog(props: Props) {
  const [input, setInput] = React.useState(props.defaultValue ?? "");
  const predicitons = React.useMemo(() => {
    if (isLoading(props.patientsState)) return [];

    const queryStr = input.trim();

    const patients =
      queryStr === ""
        ? props.patientsState.patients.toArray()
        : new Fuse(props.patientsState.patients.toArray(), {
            keys: ["fullName"],
            minMatchCharLength: 0,
          })
            .search(queryStr)
            .map((result) => result.item);

    return patients.map((patient) => ({
      id: patient.id.toString(),
      title: patient.fullName,
      patient: patient,
    }));
  }, [input, props.patientsState]);

  return (
    <AutoCompleteDialog
      isLoading={isLoading(props.patientsState)}
      isOpen={props.isOpen}
      query={input}
      placeholder={props.placeholder}
      showPredictions={predicitons.length > 0}
      predictions={predicitons}
      onChange={setInput}
      onClickPrediction={({ patient }) => props.onClickPatient(patient)}
      onRequestClose={props.onRequestClose}
    />
  );
}
